import { render, staticRenderFns } from "./CanceledTask.vue?vue&type=template&id=33dd466a&scoped=true"
import script from "./CanceledTask.vue?vue&type=script&lang=js"
export * from "./CanceledTask.vue?vue&type=script&lang=js"
import style0 from "./CanceledTask.vue?vue&type=style&index=0&id=33dd466a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dd466a",
  null
  
)

export default component.exports